export default __webpack_public_path__ + "static/15 - EPH csomópont-76d27f82b69b49a8bcddaa21b1321c6e.jpg";